import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';

class SwatchProps {
    product: Tgcc.Product;
    selected: Tgcc.Product;
    callback?: (product : Tgcc.Product) => void;
}


class _ProductSwatch extends React.Component<SwatchProps, any>{

    onClick = () => {
        if(this.props.callback)
            this.props.callback(this.props.product);

    }

    render() {
        var selected = this.props.product.colorName == this.props.selected.colorName;
        var swatchKey = this.props.product.brand + '_' + this.props.product.style;
        var swatchStyle: React.CSSProperties = {
            width: '30px',
            height: '30px',
            margin: '5px',
            backgroundPosition: '45% 45%',
            backgroundImage: 'url(' + Tgcc.getProductPath(this.props.product.thumbnail) + ')',
            outlineStyle: selected ? 'double': 'none',
            outlineWidth: '4px',
            outlineColor: 'darkgray',
            '@media (max-width:414px)': {
                width:'20px',
                height:'20px'
            }
        }
        var altText: string = this.props.product.colorName;
        return (<div style={swatchStyle} alt={altText} title={altText} onClick={this.onClick}/>)
    }

}

export var ProductSwatch = Radium(_ProductSwatch);